import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../views/home";
import Template from "../views/template";
import History from "../views/history";
import Judge from "../views/judge";
import JudgeDetail from "../views/judge/detail";
import HistoryDetail from "../views/history/detail";
import Login from "../views/login";
import Registered from "../views/registered";
import Player from "../views/player";
import PlayerDetail from "../views/player/detail";
import PersonalCases from "../views/player/personalCases";
import PrivacyPolicy from "../views/privacyPolicy";
import AddSubmission from "../views/submission/add";
import EditSubmission from "../views/submission/edit";
import Activation from "../views/activation";
import Question from "../views/question";
import JudgesLogin from "../views/judgesLogin";
import JudgesHomepage from "../views/judgesHomepage";
import JudgesHomepageDetail from "../views/judgesHomepage/detail";
import ExternalRating from "../views/externalRating";
import ExternalRatingResult from "../views/externalRating/result";
import AwardResult from "../views/awardResult";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // {
      //   path: "/judge",
      //   element: <Judge />,
      // },
      {
        path: "/template",
        element: <Template />,
      },
      {
        path: "/history",
        element: <History />,
      },
      // {
      //   path: "/judge/detail",
      //   element: <JudgeDetail />,
      // },
      {
        path: "/history/detail",
        element: <HistoryDetail />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/register",
        element: <Registered />,
      },
      {
        path: "/player",
        element: <Player />,
      },
      {
        path: "/player/detail",
        element: <PlayerDetail />,
      },
      {
        path: "/player/personalCases",
        element: <PersonalCases />,
      },
      {
        path: "/privacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/player/personalCases/add",
        element: <AddSubmission />,
      },
      {
        path: "/player/personalCases/edit",
        element: <EditSubmission />,
      },
      {
        path: "/activation",
        element: <Activation />,
      },
      {
        path: "/question",
        element: <Question />,
      },
      {
        path: "/judgesLogin",
        element: <JudgesLogin />,
      },
      {
        path: "/judgesHomepage",
        element: <JudgesHomepage />,
      },
      {
        path: "/judgesHomepage/detail",
        element: <JudgesHomepageDetail />,
      },

      {
        path: "/externalRating",
        element: <ExternalRating />,
      },

      {
        path: "/externalRating/result",
        element: <ExternalRatingResult />,
      },
      {
        path: "/awardResult",
        element: <AwardResult />,
      },
    ],
  },
]);

export default router;
